module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    attrs: {
      "id": "_idContainer009"
    }
  }, [_c('p', {
    staticClass: "ch"
  }, [_c('a', {
    attrs: {
      "id": "_idTextAnchor000"
    }
  }), _vm._v("Prologue")]), _vm._v(" "), _c('p', {
    staticClass: "body-text-opening"
  }, [_vm._v("“Simple answer? It’s an out-of-your-ever-lovin’-mind no.” Jack MacKinnon spoke calmly into his cell, surprised that he could keep his tone and volume in check with his partner’s suggestion. “Did you hear me, Wade?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I heard.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“But...?” Good or bad, there was always a but with Wade.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I haven’t asked a favor from you in a long time, Jack. I wouldn’t be begging now if it wasn’t important. There’s barely time.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("His partner wasn’t attempting to talk him into changing his mind. There were lots of pauses and a tension he hadn’t heard since they’d been in the Department of Public Safety patrolling the border. The feel of the call made Jack uneasy.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Are you in trouble?”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I’ve got everything handled—”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Except the one little favor. I would if I could get away. You know what week it is. What my father expects. I don’t have any extra time to babysit.” Whining wasn’t his thing.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Or at least it hadn’t been. But he recognized the words. Recognized the tired sound of his own voice. Recognized how busy he was dealing with the mundane while his partner got into...what? He didn’t know what trouble Wade’s intuition was getting him into. Most of the time he didn’t even know if it was an approved operation or not.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“I thought I could make her flight and be there when she left the airport, but I was...delayed.” Wade’s voice shook. It never shook.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Dammit, was that a gunshot?” Jack asked, but he recognized weapons firing. “Hang up and call for backup. Now.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("No response. There was shuffling, heavy breathing like his partner was running. If Wade was in trouble and had still taken time to ask for a favor, then Jack didn’t have a choice. He had to say yes. “You owe me, and not just anything. I decide what and when.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“Bergstrom Airport. You should get going. I’ll text details as soon as I get...um...free. Gotta run.”")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("The line disconnected.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("Wade probably meant that last word literally. But running from whom? Or what group? That was the part that bothered Jack the most. He didn’t know which. All he could do was hope his partner was on the right side and not risking both their careers.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("He jerked open the drawer with his keys and stared at the ring next to his holstered weapon. Yes? No?")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("One little favor...")])]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("It never hurt to be prepared. He scooped up both.")]), _vm._v(" "), _c('p', {
    staticClass: "body-text"
  }, [_vm._v("“You’re going to owe me, Wade. And this time, I intend to collect.”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e064fd9","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Prologue.vue
// module id = 81
// module chunks = 0